import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props{
    path:string
}

const Text = ({path}: Props) => {
    const { t } = useTranslation();
    return <React.Fragment>{t(path)}</React.Fragment>
};

export default Text;
